<template>
	<div class="container">
		<div class="row">
		</div>
		<div v-if="!current_user.name" class="row">
			<div class="col-md-6">
				<section class="card mb-3">
					<h5 @click="show_reg = !show_reg" class="card-header">
						<b class="btn border-da">LOGIN</b><b class="btn border-da ml-2">REGISTER</b>
					</h5>
					<p class="card-body">
					  <form v-model="valid" ref="reg_4m" lazy-validation class="mx-5">
					  	<p>
								<input type="text" maxlength=32 placeholder="Name" v-if="show_reg" v-model="name" class="form-control mb-2" required>
								<input type="email" placeholder="Email" v-model="email" :rules="emailRules" class="form-control mb-2" required>
								<input type="password" minlength=6 maxlength=64 placeholder="Password" v-model="pword" class="form-control mb-2" required>
								<input type="password" minlength=6 maxlength=64 placeholder="Confirm Password" v-if="show_reg" v-model="pword_cm" class="form-control">
							</p>
							<b :class="[name ? activeClass : '']" @click="submit_reg" :disabled="!valid" class="btn border-da">
								<b v-if="show_reg">Register</b>
								<b v-if="!show_reg">Login</b>
							</b>
							<b @click="clear_reg" class="btn border-da ml-2">Clear</b>
							<b v-if="!show_reg" @click="pword_4g(email)" class="badge">Forgot password</b>
						</form>
					</p>
				</section>
				<div class="card d-none"><!--Introduced this card since having challenges connecting mongo on hosted plat4m 021220-->
					<div class="card-body">
						<h1>Try Logging in later</h1>
					</div>
				</div>
			</div>
			<div class="col-md-6" style="text-align:start!important">
				<div class="card mb-3">
					<h3 class="card-header">Why Register?</h3>
					<p class="card-body">
						<ol class="list-group">
							<li class="list-group-item">You will have a better user experience; e.g. be able to make likes &amp; comments on poems.</li>
							<li class="list-group-item">Be inline for discounts on purchases on our selected products.</li>
							<li class="list-group-item">Eligibility for offical translation collaborations.</li>
						</ol>
					</p>	
				</div>
			</div>
		</div><!--End 1st Row-->
		<div v-if="current_user.name" class="row">
			<div v-if="!edit_prof" class="col-12">
        <div class="media">
        	<div>
          	<img v-if="current_user.img" class="img-thumbnail d-flex align-self-center ml-1 mr-1" alt="avatar" src="img/wbsLogo.png">
          	<i class="fa fa-user fa-5x"></i>
        	</div>
          <div class="media-body ml-3" style="text-align:start!important">
            <h5 class="mt-0">{{current_user.name}}</h5>
            <h6>
            	{{current_user.email}}
            </h6>
            <b @click="show_token = !show_token" :aria-expanded="show_token ? 'true' : 'false'" class="btn btn-sm border-da my-3">Edit Profile</b>
            <div v-if="show_token" class="">
	            <p >
	            	Click on the button below to request a profile reset token,<br>
	            	without which you cannot proceed.<br>
	            	The token is sent to your registered email immediately.<br>
	            </p>
	            <b @click="get_token" class="btn btn-sm border-da">Get token</b><hr>
	            <p>
	            	Copy the token and paste it into the given field below and submit,<br>
	            	If the token is valid, you will then be directed to your profile editing page.<br><br>

	            	Goodluck.
	            	<form>
	            		<input type="text" minlength=8 placeholder="Profile editing token" v-model="prof_token" class="form-control" required>
	            		<b @click="verify_token" class="btn btn-sm border-da my-3">Submit token</b>
	            	</form>
	            </p>
            </div>
          </div>
        </div>
			</div>
			<div v-if="edit_prof" class="col-12">
				<div class="col-lg-6 py-5">
					<h3 class="mb-3" style="text-align:start;"><i @click="edit_prof=false" class="fa fa-chevron-left"></i> Edit Profile</h3>
					<div class="media">
	        	<form class="" style="width: 11rem;">
	          	<img v-if="!current_user.img" class="img-thumbnail d-flex align-self-center" alt="avatar" src="../assets/img/avatar.png" style="width: 100%; max-height: 13rem;background-position: center; object-fit: cover;">
							<label for="p-img"><b class="btn btn-sm border-da mt-2">Choose avatar <i class="fa fa-check"></i></b></label><input type="file" id="p-img" name="p-img" accept="image/*" hidden>
	        	</form>
	          <div class="media-body ml-3" style="text-align:start!important">
							<h5 class="">Username &amp; Email</h5>
							<form ref="edit_prof_4m" lazy-validation class="form">
								<input type="text" maxlength=32 v-model="name" :placeholder="current_user.name" class="form-control my-2">
								<input type="email" minlength=5 maxlength=64 v-model="email" :placeholder="current_user.email" class="form-control my-2">
								<b @click="submit_prof" name="submit_prof" class="btn btn-sm border-da my-2">Submit</b>
							</form><hr>

							<h5 @click="show_pword = !show_pword" :aria-expanded="show_pword ? 'true' : 'false'" class="btn border-da">Change password</h5>
							<form v-if="show_pword" ref="edit_pword_4m" lazy-validation class="form">
								<input type="password" minlength=6 maxlength=64 placeholder="Current password" v-model="pword" class="form-control my-2" required>
								<input type="password" minlength=6 maxlength=64 placeholder="New password" v-model="pword_n" class="form-control my-2" required>
								<input type="password" minlength=6 maxlength=64 placeholder="Confirm new password" v-model="pword_cm" class="form-control my-2" required>
								<b @click="update_pword" name="update_pword" class="btn btn-sm border-da my-2">Submit</b>
							</form>
	          </div>
	        </div>
				</div>
			</div>
		</div><!--End Row-->
	</div><!--End Container-->
</template>

<script>
	import axios from 'axios';

	export default {
		data: () => ({
			valid: true,
			name: '',
			email: '',
			pword: '',
			pword_n: '',
			pword_cm: '',
			activeClass: 'active',
			response: '',
			emailRules: [
				v => !!v || 'E-mail is required',
				v => /\S+@\S+\.\S+/.test(v) || 'E-mail must be valid',
			],
			show_reg: false,
			edit_prof: false,
			show_pword: false,
			show_token: false,
			prof_token: ''
		}),
		computed: {
			current_user() {
				return this.$store.getters.fetchUser;
			}
		},
		methods: {
			blanks(){
				this.$swal('Cannot post blanks!!','','error');
				return;
			},
			test(){
				;
			},
			submit_reg() {
				if ((this.email || this.name) != '') {
					if(this.pword.length < 6){
						this.$swal("Password length must be at least 6 characters!!",'','error');
						return;
					}
					if(this.show_reg == true){
						if(this.pword !== this.pword_cm){
							this.$swal("Password mismatch!!",'','error');
							return;
						}
					}
					return axios({
						method: 'post',
						data: {
							name: this.name,
							email: this.email.toLowerCase(),
							pword: this.pword,
							reg: this.show_reg
						},
						url: '../../api/auth',
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then((res) => {
						if(this.show_reg == false){
							window.localStorage.setItem('Bearer', res.data.token);
          		this.$store.commit('USER', res.data.user);
							this.$router.push({ name: 'Poems' });
						} else { 
							this.show_reg = false;
							this.$swal(res.data.status,'','success');
						}
					})
					.catch((error) => {
						const message = error.response;
						if(message.data.status){
							this.$swal(message.data.status,'','error');
						} else if(message.data.err){
							console.log(message)
							this.$swal('Try another email!!','','error');
						} else {
							this.$swal('Try again later','','error');
						}
					});
				} else {
					this.blanks();
				}
			},
			clear_reg() {
				this.$refs.reg_4m.reset();
			},
			pword_4g(email){
				if(email){
					return axios({
						method: 'post',
						data: {
							pword_4g: true,
							email: this.email.toLowerCase()
						},
						url: '../../api/auth',
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then((res)=>{
						if(res.data.em){
							this.$swal(
								'Check your email for a temporary password',
								'We recommend you immediately change this to one of your choosing',
								'success');	
						} else {
							this.$swal('User does not exist!!','','error');
						}
					})
					.catch((err)=>{})
				}
				if(!email){
					this.$swal('Enter your registered email','','error');
				} return;
			},
			get_token() {
				this.date = new Date(this.current_user.updatedAt);//token valid for 30 mins only
				if((this.current_user.token_prf_edt) && (new Date() - this.date <= 1800000)){
					this.$swal('Already have a valid token!','','info');
					return;
				}			
        const token = window.localStorage.getItem('Bearer');
				return axios({
					method: 'patch',
					data: {
						edit_token: true
					},
					url: '../../api/auth',
					headers: {
            'Authorization': `Bearer ${token}`,
						'Content-Type': 'application/json'
					},
				})
				.then((res) => {
        	this.$store.commit('USER', res.data.user);
					this.$swal('Check your email for the token!','','success');
				})
				.catch((err) => {
				}); this.blanks();
			},
			verify_token() {
				if(this.prof_token == ''){
					this.blanks();
					return;
				}
				if(this.prof_token === this.current_user.token_prf_edt){
					this.edit_prof = true;
	        const token = window.localStorage.getItem('Bearer');
					return axios({
						method: 'patch',
						url: '../../api/auth',
						headers: {
	            'Authorization': `Bearer ${token}`,
							'Content-Type': 'application/json'
						},
					})
					.then((res) => {
	        	this.$store.commit('USER', res.data.user);
					})
					.catch((err) => {
					}); this.blanks();
				} else {
					this.$swal('Check your token & try again!!','','error');
				}
			},
			submit_prof() {
				if(this.name==this.current_user.name){
					this.$swal('Use another name!','','error');
					return;
				}
				if ((this.email != '' && this.email!=this.current_user.email) || (this.name.length>2)) {
          const token = window.localStorage.getItem('Bearer');
					return axios({
						method: 'patch',
						data: {
							name: this.name,
							email: this.email.toLowerCase()
						},
						url: '../../api/auth',
						headers: {
              'Authorization': `Bearer ${token}`,
							'Content-Type': 'application/json'
						}
					})
					.then((res) => {
          	this.$store.commit('USER', res.data.user);
          	this.$refs.edit_prof_4m.reset();
						this.$swal('Done!','','success');
					})
					.catch((err) => {
					})
				}	else this.blanks();
			},
			update_pword() {
				if((this.pword.length < 6)){
					this.$swal('Minimum password length = 6','','error')
					return;/*to record pword fails, block account after 7 successive attempts*/
				}
				else if((this.pword_n != this.pword_cm) || (!this.pword_n.length)){
					this.$swal('Dololo!!','','error');
					return;	
				}
				else {
          const token = window.localStorage.getItem('Bearer');
					return axios({
						method: 'patch',
						data: {
							pword: this.pword,
							pword_n: this.pword_n,
							pword_cm: this.pword_cm
						},
						url: '../../api/user_edit',//http://localhost:8081/users/:id
						headers: {
              'Authorization': `Bearer ${token}`,
							'Content-Type': 'application/json'
						}
					})
					.then((res) => {
						if(res.data.fine==true){
	          	this.$store.commit('USER', res.data.user);
	          	this.$refs.edit_prof_4m.reset();
							this.$swal('Update successfull!','','success');
						} else {
							this.$swal('Could not update!','','error');
						}
					})
					.catch(() => {
						console.log('Error');
					})
				}
			}
		},
	};
</script>